export const contactsData = {
  email: "sumansaurav986@gmail.com",
  phone: "7654839189, 6207463569",
  address: "Gurgaon, Haryana, India",
  sheetAPI: "",
};
